export default __webpack_public_path__ + "static/media/logo-net.6d9b1f97.svg";